import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { FeeColumnFilterPanelService, PlayerAdjustmentService } from '../../../../services';
import { StorageUtil } from '../../../../models';

@Component({
  selector: 'app-log-payment',
  templateUrl: './log-payment.component.html',
  styleUrls: ['./log-payment.component.css']
})
export class LogPaymentComponent implements OnInit {
  public reasons: any[];
  public logPaymentForm: FormGroup;
  public validationMessages = {};
  public isShowAmount = false;
  public isShowCheckNumber = false;
  public isShowTransactionId = false;
  public is_show_visible_column_panel = false;

  @Input() ClubUserProgramFeeID: string;
  @Input() ClubProgramFeeID: string;
  @Input() UserID: string;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private notificationsService: NotificationsService,
    private feeColumnFilterPanelService: FeeColumnFilterPanelService,
    private playerAdjustmentService: PlayerAdjustmentService) {
    this.validationMessages = {
      'Required': 'This field is required.'
    };
  }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.logPaymentForm = this.fb.group({
      TypeOfPayments: ['', [Validators.required]],
      Amount: [''],
      CheckNumber: [''],
      TransactionId: [''],
    });
  }

  isAmountValid() {
    return this.logPaymentForm.get('Amount').errors
      && (this.logPaymentForm.get('Amount').touched
        || this.logPaymentForm.get('Amount').dirty);
  }
  isTypeOfPaymentValid() {
    return this.logPaymentForm.get('TypeOfPayments').errors
      && (this.logPaymentForm.get('TypeOfPayments').touched
        || this.logPaymentForm.get('TypeOfPayments').dirty);
  }
  isCheckValid() {
    return this.logPaymentForm.get('CheckNumber').errors
      && (this.logPaymentForm.get('CheckNumber').touched
        || this.logPaymentForm.get('CheckNumber').dirty);
  }
  isTransactionIdValid() {
    return this.logPaymentForm.get('TransactionId').errors
      && (this.logPaymentForm.get('TransactionId').touched
        || this.logPaymentForm.get('TransactionId').dirty);
  }

  typeOfPaymentChange(event) {
    event.stopPropagation();
    const paymentType = this.logPaymentForm.get('TypeOfPayments').value;
    if (paymentType === '1') {
      this.removeValidaion('TransactionId');
      this.requiredValidation('Amount');
      this.requiredValidation('CheckNumber');
      this.isShowAmount = true;
      this.isShowCheckNumber = true;
      this.isShowTransactionId = false;
    } else if (paymentType === '2') {
      this.requiredValidation('Amount');
      this.removeValidaion('CheckNumber');
      this.requiredValidation('TransactionId');
      this.isShowAmount = true;
      this.isShowCheckNumber = false;
      this.isShowTransactionId = true;
    } else if (paymentType === '3') {
      this.requiredValidation('Amount');
      this.removeValidaion('CheckNumber');
      this.removeValidaion('TransactionId');
      this.isShowAmount = true;
      this.isShowCheckNumber = false;
      this.isShowTransactionId = false;
    }
  }

  requiredValidation(name) {
    const control = this.logPaymentForm.get(name);
    control.setValidators([Validators.required]);
    control.updateValueAndValidity();
  }
  removeValidaion(name) {
    const control = this.logPaymentForm.get(name);
    control.reset();
    control.clearValidators();
    control.updateValueAndValidity();
  }
  validateUi() {
    Object.keys(this.logPaymentForm.controls).forEach(field => {
      const control = this.logPaymentForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  onSubmit(event, formStatus) {
    event.stopPropagation();
    if (formStatus === 'VALID') {
      const paymentType = this.logPaymentForm.get('TypeOfPayments').value;

      const requestBody = {
        UserID: this.UserID,
        ClubProgramFeeID: Number(this.ClubProgramFeeID),
        ClubUserProgramFeeID: this.ClubUserProgramFeeID,
        ChargeTypeID: 1,
        Amount: Number(this.logPaymentForm.value.Amount),
        Auth: '',
        PaymentTypeID: Number(this.logPaymentForm.value.TypeOfPayments),
        PaymentType: '',
        AddedBy: +StorageUtil.userID
      };

      if (paymentType === '1') {
        requestBody.Auth = this.logPaymentForm.value.CheckNumber;
        requestBody.PaymentType = 'Check';

      } else if (paymentType === '2') {
        requestBody.Auth = this.logPaymentForm.value.TransactionId;
        requestBody.PaymentType = 'Credit Card';
      } else {
        requestBody.PaymentType = 'Cash';
      }

      console.log('Req Body - ', requestBody);

      event.target.innerHTML = 'Saving <i class="fa fa-spinner fa-spin push-5-r"></i>';
      event.target.disabled = true;
      this.playerAdjustmentService.saveLogPayment(requestBody).subscribe((data: any) => {
        event.target.innerHTML = 'Save';
        event.target.disabled = false;
        this.clearFormData();
        this.closeSideOverlay();
        this.alertMessage('success', data.result);
      }, error => {
        this.alertMessage('error', error.statusText);
      });
    } else {
      this.validateUi();
    }
  }

  clearFormData() {
    this.logPaymentForm.reset();
    this.isShowAmount = false;
    this.isShowCheckNumber = false;
    this.isShowTransactionId = false;
  }

  onReset(event) {
    event.stopPropagation();
    this.clearFormData();
    this.closeSideOverlay();
  }

  closeSideOverlay() {
    this.feeColumnFilterPanelService.setToggleFilterColumnsPanel(false);
  }

  alertMessage(status, message) {
    const toast = this.notificationsService.success(status, message, {
      timeOut: 3000,
      showProgressBar: true,
      pauseOnHover: false,
      clickToClose: false
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/member-billing-info/log-payment/log-payment.component.ts